import { useEffect, useState } from 'react';
import {
  currentClockInZone,
  todayStr,
  formatArabicDate,
  formatHijriDate,
} from '../lib/dates.js';
import { ROLE_LABELS, isAdmin } from '../lib/constants.js';
import { navigate } from '../lib/router.js';

const DEFAULT_TITLE = 'سجلّ مواعيد المحافظ';

export default function Header({ user, settings, onSignOut, isAdminRoute }) {
  const [clock, setClock] = useState(() => currentClockInZone());
  const [today, setToday] = useState(() => todayStr());

  // Ticks every second. Recomputing today's date here means the header rolls
  // over correctly at midnight without a page reload.
  useEffect(() => {
    const timer = setInterval(() => {
      setClock(currentClockInZone());
      setToday((current) => {
        const next = todayStr();
        return next === current ? current : next;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const hijri = formatHijriDate(today);
  const orgLine = [settings?.org_name, settings?.dept_name].filter(Boolean).join(' — ');
  const roleLabel = user.isDisplay ? 'عرض المحافظ' : ROLE_LABELS[user.role] || user.role;

  return (
    <header className="site-header">
      <div className="header-inner">
        <div className="header-identity">
          <div className="header-seal" aria-hidden="true">
            ✦
          </div>
          <div className="header-titles">
            <h1>{settings?.app_title || DEFAULT_TITLE}</h1>
            {orgLine && <div className="header-subtitle">{orgLine}</div>}
          </div>
        </div>

        <div className="header-actions">
          <span className="role-tag">{roleLabel}</span>

          {/* A display screen is unattended, so it gets no navigation or
              sign-out controls that a passer-by could press. */}
          {!user.isDisplay && isAdmin(user) && (
            <button
              type="button"
              className="btn btn-ghost btn-sm"
              style={{ color: '#fff' }}
              onClick={() => navigate(isAdminRoute ? '/' : '/admin')}
            >
              {isAdminRoute ? 'الجدول اليومي' : 'الإعدادات'}
            </button>
          )}

          {!user.isDisplay && (
            <button
              type="button"
              className="btn btn-ghost btn-sm"
              style={{ color: '#fff' }}
              onClick={onSignOut}
            >
              خروج
            </button>
          )}
        </div>

        <div className="header-meta">
          <div className="header-clock" dir="ltr">
            {clock}
          </div>
          <div className="header-date">{formatArabicDate(today)}</div>
          {hijri && <div className="header-hijri">{hijri}</div>}
        </div>
      </div>
    </header>
  );
}
